// WO-23: say what a TCGplayer price is, in the shopper's words. Market Price = what cards actually sold for (TCGplayer's
// `market`, built from recent sales). Asking Price = no recent sales, only what sellers ask (`mid`), shown only when a
// real sale backs it up.
export const isAskingPrice = (priceType) => priceType === 'mid' || priceType === 'low';

export const priceLabel = (priceType) => (isAskingPrice(priceType) ? 'Asking Price' : 'Market Price');

export const priceHint = (priceType) => (isAskingPrice(priceType)
  ? 'No recent sales: what sellers are asking on TCGplayer, checked against past sales.'
  : 'Based on recent sold prices on TCGplayer.');

export const NO_SALES_TEXT = 'No recent sales';
